import React from 'react';

const PageArrowNext = () => (
  <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#DDDDDD" fillRule="evenodd" clipRule="evenodd" d="M0.753373 8.05811C0.751326 7.81075 0.845075 7.57184 1.0157 7.38958L3.80428 4.50073L1.0157 1.61189C0.661432 1.23507 0.661432 0.654852 1.0157 0.278032C1.18092 0.101338 1.41422 0.000732422 1.65874 0.000732422C1.90327 0.000732422 2.13657 0.101338 2.30178 0.278032L5.73307 3.83413C6.08898 4.20957 6.08898 4.79061 5.73307 5.16605L2.30506 8.72343C2.13984 8.90013 1.90655 9.00073 1.66202 9.00073C1.4175 9.00073 1.1842 8.90013 1.01898 8.72343C0.848563 8.54233 0.754782 8.30448 0.756652 8.05811" />
  </svg>
);

export default PageArrowNext;